import React, { FC } from 'react';
import { ConsumerTokenOperation } from '../consumer.types';
import Spinner from '../../../UIComponents/Spinner';
import { convertDateToNeedFormat } from '../../../utils/convertDateHandlers';
import cls from './ConsumerTokensList.module.scss';

interface ConsumerTokensListProps {
  // TODO: fill from the token history endpoint once apisupport exposes it
  tokenOperations?: ConsumerTokenOperation[];
  isLoading?: boolean;
}

const ConsumerTokensList: FC<ConsumerTokensListProps> = ({
  tokenOperations,
  isLoading = false,
}) => {
  if (isLoading) return <Spinner />;
  if (!tokenOperations || tokenOperations.length === 0)
    return (
      <h5 data-testid="without-tokens" className="title-5 mt-3">
        Token history is not available yet
      </h5>
    );
  return (
    <div>
      <ul className={cls.Header}>
        <li className="regular-text">Operation Date</li>
        <li className="regular-text">Type</li>
        <li className="regular-text">Tokens</li>
        <li className="regular-text">Reason</li>
      </ul>
      <ul data-testid="tokens-list" className={cls.List}>
        {tokenOperations.map((operation) => (
          <li key={operation.id} className={cls.TokenItem}>
            <span>
              {convertDateToNeedFormat({ date: operation.createdAt, format: 'datetime' })}
            </span>
            <span
              className={
                operation.direction === 'TOKEN_CREDIT' ? cls.CreditOperation : cls.DebitOperation
              }
            >
              {operation.direction === 'TOKEN_CREDIT' ? 'Deposit' : 'Withdrawal'}
            </span>
            <span>
              {operation.direction === 'TOKEN_CREDIT' ? '+' : '-'}
              {operation.amount}
            </span>
            <span className={cls.Comment}>{operation.comment}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ConsumerTokensList;
